import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
export const getFormattedDate = (date, locale = 'en') => {
    return dayjs(date).locale(locale).format('DD/MM/YYYY HH:mm:ss');
};
export const getShortFormattedDate = (date, locale = 'en') => {
    return dayjs(date).locale(locale).format('DD/MM/YYYY');
};
export const getShortFormattedDateAsMonthAndYearOnly = (date, locale = 'en') => {
    return dayjs(date).locale(locale).format('MM/YY');
};
export const getStringDate = (date, locale) => {
    if (locale == undefined) {
        locale = 'en';
    }
    if (locale === 'fr') {
        return dayjs(date).locale(locale).format('D MMMM YYYY');
    }
    else if (locale === 'en') {
        return dayjs(date).locale(locale).format('MMMM D, YYYY');
    }
    else {
        return date.toString();
    }
};
export const formatGrantTimelineDate = (date, locale) => {
    if (!date)
        return '';
    const timelineDate = dayjs.utc(date);
    if (!timelineDate.isValid())
        return '';
    if (locale == undefined) {
        locale = 'en';
    }
    if (locale === 'fr') {
        return timelineDate.locale(locale).format('D MMMM YYYY');
    }
    else if (locale === 'en') {
        return timelineDate.locale(locale).format('MMMM D, YYYY');
    }
    else {
        return timelineDate.format('YYYY-MM-DD');
    }
};
const getEnglishOrdinal = (day) => {
    const remainder = day % 100;
    if (remainder >= 11 && remainder <= 13)
        return 'th';
    switch (day % 10) {
        case 1:
            return 'st';
        case 2:
            return 'nd';
        case 3:
            return 'rd';
        default:
            return 'th';
    }
};
export const formatReadableDate = (date, locale, emptyValue = '') => {
    if (!date)
        return emptyValue;
    const parsedDate = dayjs.utc(date);
    if (!parsedDate.isValid())
        return emptyValue;
    const utcDate = new Date(Date.UTC(parsedDate.year(), parsedDate.month(), parsedDate.date()));
    if (locale === null || locale === void 0 ? void 0 : locale.startsWith('fr')) {
        return new Intl.DateTimeFormat('fr-CA', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            timeZone: 'UTC',
        }).format(utcDate);
    }
    const day = parsedDate.date();
    const month = new Intl.DateTimeFormat('en-US', {
        month: 'long',
        timeZone: 'UTC',
    }).format(utcDate);
    return `${month} ${day}${getEnglishOrdinal(day)} ${parsedDate.year()}`;
};
export const toGrantTimelinePickerValue = (date) => {
    if (!date)
        return null;
    const timelineDate = dayjs.utc(date);
    return timelineDate.isValid() ? timelineDate : null;
};
export const fromGrantTimelinePickerValue = (date, boundary) => {
    if (!date)
        return null;
    if (!date.isValid())
        return null;
    const selectedDayStart = dayjs.utc(Date.UTC(date.year(), date.month(), date.date()));
    const normalizedDate = boundary === 'end'
        ? selectedDayStart.add(1, 'day').subtract(1, 'second')
        : selectedDayStart;
    return normalizedDate.toDate();
};
export const getLongStringDate = (date, locale) => {
    if (locale == undefined) {
        locale = 'en';
    }
    if (locale === 'fr') {
        return dayjs(date).locale(locale).format('DD MMMM YYYY - HH:mm:ss');
    }
    else if (locale === 'en') {
        return dayjs(date).locale(locale).format('MMMM DD, YYYY - HH:mm:ss');
    }
    else {
        return date.toString();
    }
};
export const getStringDateFromString = (date, locale) => {
    if (!date)
        return '';
    if (locale === undefined) {
        locale = 'en';
    }
    if (locale === 'fr') {
        return dayjs(date).locale(locale).format('DD MMMM YYYY');
    }
    else if (locale === 'en') {
        return dayjs(date).locale(locale).format('MMMM DD, YYYY');
    }
    else {
        return date.toString();
    }
};
export const getStringDateAndTime = (date, locale) => {
    if (locale == undefined) {
        locale = 'en';
    }
    if (locale === 'fr') {
        return dayjs(date).locale(locale).format('DD MMMM YYYY - HH:mm');
    }
    else if (locale === 'en') {
        return dayjs(date).locale(locale).format('MMMM DD, YYYY - HH:mm');
    }
    else {
        return date.toString();
    }
};
export default getFormattedDate;
